export const pgPdfs = {
    "State Board": {
      
    },
  };
  